// extracted by mini-css-extract-plugin
export default {"imageContainer":"Xaa-z","summaryPar":"Yaa-z","ratingCategories":"Zaa-z","reviewerInfo":"_aa-z","reviewTypes":"aba-z","expanded":"bba-z"};